/**
 * Hub → spoke internal linking.
 *
 * Each money page (the single commercial-intent page for a keyword cluster)
 * links down to the informational articles that support it, and every one of
 * those articles carries a contextual link back up using the head term as
 * anchor text. This is what keeps the post-consolidation cluster readable to
 * crawlers as one hub with spokes rather than a set of competing pages.
 *
 * Keys are full route paths; values are blog slugs, most important first.
 */
export const clusterSpokes: Record<string, string[]> = {
  "/electrical-services/commercial-electrical-contractor": [
    "commercial-electrician-louisville-ky",
    "how-to-choose-commercial-electrical-contractor",
    "commercial-electrical-repair-common-issues",
  ],
  "/electrical-services/electrical-service-and-repair": [
    "commercial-electrical-repair-common-issues",
    "commercial-electrician-louisville-ky",
  ],
  "/electrical-services/emergency-electrical-service": [
    "24-hour-emergency-electrician-louisville",
    "emergency-electrician-louisville-southern-indiana",
  ],
  "/electrical-services/preventative-maintenance": [
    "commercial-electrical-repair-common-issues",
    "how-to-choose-commercial-electrical-contractor",
  ],
  "/hvac-services/commercial-hvac": [
    "commercial-hvac-contractor-louisville-ky",
    "guide-to-commercial-hvac-systems",
    "commercial-hvac-maintenance-louisville-ky",
  ],
  "/hvac-services/hvac-preventative-maintenance": [
    "commercial-hvac-maintenance-louisville-ky",
    "commercial-hvac-preventative-maintenance-cost-guide",
  ],
  "/energy-management/lighting-retrofits": [
    "commercial-lighting-retrofit-louisville-ky",
  ],
  "/energy-management/lighting-design": [
    "commercial-lighting-retrofit-louisville-ky",
  ],
  "/energy-management/energy-audits": [
    "energy-audit-louisville-ky",
    "ashrae-level-2-audit-cost-kentucky",
  ],
  "/energy-management/energy-bill-analysis": [
    "save-on-electricity-bills-energy-audit",
    "energy-audit-louisville-ky",
  ],
};
